import { FilterItem, FilterItemInterface } from './filter-item.model';

export interface FilterInterface extends FilterItemInterface {
  enabled?: boolean;
  items?: FilterItemInterface[];
}

export class Filter extends FilterItem implements FilterInterface {
  public enabled?: boolean;
  public items?: FilterItemInterface[];

  constructor({
    enabled = undefined,
    items = undefined,
  }: FilterInterface) {
    super(arguments[0]);
    this.enabled = enabled;
    this.items = items;
  }
}
